import {
    SET_PROGRESS_LOG
} from './actionTypes'

export function setProgressLog(progressLog){
    return {type : SET_PROGRESS_LOG, progressLog}
}
